import React from "react";
import ClientEditCard from '../../components/ClientEditcard/ClientEditCard'; 
import { useLocation } from 'react-router-dom';

const ClientEditCardPage = () => {
    const location = useLocation();
    console.log(location);  

    return (
        <div className="new-edit-container">
            <div>
                <ClientEditCard location={location} /> 
            </div>
        </div>
    );
};

export default ClientEditCardPage;

